// AIDEV-NOTE: Registro de push nativo (FCM/APNs).
//             Em nativo: PushNotifications.requestPermissions() -> register() -> token.
//             Em web: delegar ao usePushNotifications hook (VAPID/Service Worker).
import { Platform } from './platform.detect';

export async function registerPushToken(): Promise<void> {
  if (!Platform.isNative()) {
    // Web push e gerenciado pelo usePushNotifications hook via Service Worker
    return;
  }
  const { PushNotifications } = await import('@capacitor/push-notifications');
  const { Capacitor } = await import('@capacitor/core');

  const permResult = await PushNotifications.requestPermissions();
  if (permResult.receive !== 'granted') {
    console.warn('[Push] Permissao negada pelo usuario');
    return;
  }

  await PushNotifications.register();

  PushNotifications.addListener('registration', async (token) => {
    const platform = Capacitor.getPlatform() as 'ios' | 'android';
    try {
      await fetch('/api/notifications/subscribe-native', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ token: token.value, platform })
      });
    } catch (err) {
      console.error('[Push] Falha ao registrar token:', err);
    }
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.error('[Push] Erro de registro:', err.error);
  });
}

export async function addForegroundPushListener(
  callback: (title: string, body: string, data?: Record<string, string>) => void
): Promise<() => void> {
  if (!Platform.isNative()) {
    return () => {};
  }
  const { PushNotifications } = await import('@capacitor/push-notifications');
  const handle = await PushNotifications.addListener('pushNotificationReceived', (notification) => {
    callback(
      String(notification.title ?? ''),
      String(notification.body ?? ''),
      notification.data as Record<string, string>
    );
  });
  return () => handle.remove();
}
